


























import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      state: {
        /** Whether the upload is in progress or not */
        attemptingUpload: false,
      },
    }
  },
  computed: {
    /** Text for the "save" button depending on if the upload is in progress or not */
    saveLogoButtonText(): string {
      return this.state.attemptingUpload ? 'Uploading ...' : 'Save Logo'
    },
  },
  methods: {
    changeIsStaged(): boolean {
      return this.$launcher.uiSettings.isChangeStagedFor('clientLogo')
    },
    /** Propagate state of newly selected file */
    async logoFileSelected() {
      const fileInput = this.$refs.fileInput as HTMLInputElement
      await this.$launcher.uiSettings.logoSelected(fileInput.files)
    },
    /** Upload the new logo */
    async uploadNewLogo() {
      // If we're already uploading then just display a message
      if (this.state.attemptingUpload) {
        this.$launcher.bootState.tedsUi.notifications.error(`Upload in progress, please wait.`)
      }
      // Else upload new logo
      else {
        try {
          this.state.attemptingUpload = true
          await this.$launcher.uiSettings.updateLogo()
        } finally {
          this.state.attemptingUpload = false
        }
      }
    },
    /** Remove the new select logo, unless upload has already started */
    removeNewSelectedLogo() {
      // If we're already uploading then just display a message
      if (this.state.attemptingUpload) {
        this.$launcher.bootState.tedsUi.notifications.error(`Upload in progress, please wait.`)
      } else {
        this.$launcher.uiSettings.rollbackStagedChange('clientLogo')
      }
    },
  },
})
